function NewHoneypotSet() {
    return {
        id: null,       
        name: "New Honeypot Set",
		startDate: null,
		endDate: null,		
		questions: [],
		enabled: 0,
      }
}
export default NewHoneypotSet;